import { useState, useContext, useEffect, useCallback } from 'react';
import { Edit, PhonelinkSetup } from '@mui/icons-material';
import { Button, IconButton, Tooltip } from '@mui/material'

import { getGridStringOperators, GridColDef, GridFilterModel, GridFilterOperator, GridRenderCellParams, GridToolbar, GridTreeNodeWithRender } from '@mui/x-data-grid';
import { CUSTOMER_DETAIL_FIELDS, ICustomerSummary } from '../../Models/Customer';
import { CustomerContext } from '../../contexts/CustomerContext';
import Title, { CARD_HEADER, CARD_HEADING } from '../custom/Title';
import useService from '../../hooks/useService';
import { fetchCustomerPan, getCustomersCount, getCustomers as getCustomersService } from '../../services/Customer';
import Table from '../custom/Table';
import CustomerPanUpload from '../_CustomerSetup/CustomerPanUpload';
import Modal from '../Modals';
import FileUploadIcon from '@mui/icons-material/FileUpload';
import Divider from '../custom/Divider';
import { useNavigate } from 'react-router-dom';
import { PATHS } from '../../utils/constant';
import CustomerAadharUpload from '../_CustomerSetup/CustomerAadharUpload';
import ConfirmPhoneModal from '../Modals/ConfirmPhoneModal';
import AssignmentTurnedInIcon from '@mui/icons-material/AssignmentTurnedIn';
import DownloadIcon from '@mui/icons-material/Download';

const CustomerSetup = () => {
  const navigate = useNavigate()
  const [showUploadPAN, setShowUploadPAN] = useState<ICustomerSummary | boolean>(false)
  const [showUploadAadhar, setShowUploadAadhar] = useState<ICustomerSummary | boolean>(false)
  const [showMobileInput, setShowMobileInput] = useState<boolean | string>(false)
  const { customers, resetCustomer } = useContext(CustomerContext)
  const { execute } = useService()
  const [count, setCount] = useState(0)
  const [paginationModel, setPaginationModel] = useState({
    page: 0,
    pageSize: 10
  })
  const [filterModel, setFilterModel] = useState<GridFilterModel>({
    items: []
  })

  console.log("customers are---", customers)
  const confimrPhoneHandler = () => {
    setShowMobileInput(false)
    if (typeof showMobileInput === 'boolean') navigate(PATHS.CUSTOMER_SETUP)
    else fetchCustomers()
  }

  const handleClosePAN = () => {
    setShowUploadPAN(false)
  }
  const handleCloseAadhar = () => {
    setShowUploadAadhar(false)
  }

  const fetchCustomers = () => {
    execute(() => getCustomersService({
      pageSize: paginationModel.pageSize,
      pageNumber: paginationModel.page,
      filterModel: filterModel
    }))
  }

  const fetchCustomersCount = async () => {
    const {data} = await execute(() => getCustomersCount({ filterModel }))
    if(data != null) setCount(data.count)
  }

  const handleCustomer = () => {
    setShowMobileInput(true)
  }

  useEffect(() => {
    resetCustomer()
    fetchCustomers()
  }, [])

  useEffect(()=>{
    fetchCustomers()
    fetchCustomersCount()
  }, [paginationModel, filterModel.items[0]?.value])

  // Create a custom set of filter operators, excluding the ones you don't want.
  const customStringOperators: GridFilterOperator[] = getGridStringOperators().filter((operator) => {
    return operator.value !== 'contains' && operator.value !== 'endsWith' && operator.value !== "startsWith";
  });

  const getCustomerColumns = () => {

    return CUSTOMER_DETAIL_FIELDS.map(inboundField => {
      const row: GridColDef<ICustomerSummary> = {
        field: inboundField.id,
        headerName: inboundField.label,
        width: 110,
        align: 'left'
      }

      switch (inboundField.id) {
        case "actions":
          row.filterable = false;
          row.renderCell = params => {
            return <>
              <Tooltip title='Edit'>
                <IconButton onClick={() => navigate(PATHS.CUSTOMER_SETUP + '/' + params.id as string)} ><Edit /></IconButton>
              </Tooltip>
              <Tooltip title='Update Mobile Number'>
                <IconButton onClick={() => setShowMobileInput(params.id as string)} ><PhonelinkSetup /></IconButton>
              </Tooltip>
            </>
          }
          row.width = 100;
          break;

        case "pan":
          row.filterable = false;
          row.renderCell = params => {
            return <>
              <Tooltip title={!params.row?.kycInfo?.nameProofType ? 'Upload PAN' : 'PAN already uploaded'}>
                <IconButton onClick={() => {
                  // if (params.row?.kycInfo?.nameProofType !== 'pan')
                    setShowUploadPAN(params.row);
                }}>
                  {params.row?.kycInfo?.nameProofType === 'pan' ? <AssignmentTurnedInIcon /> : <FileUploadIcon />}
                </IconButton>
              </Tooltip>
            </>
          }
          row.width = 60;
          break;

        case "panDownload":
          row.filterable = false;
          row.headerName = "PAN Download";
          row.renderCell = (params) => {
            const handleDownload = async () => {
              try {
                const dgCustomerRefNo = params.row?.dgCustomerRefNo;
                const {data} = await execute(() => fetchCustomerPan(dgCustomerRefNo as string));
                const panUrl = data?.url;

                if (panUrl) {
                  const link = document.createElement("a");
                  link.href = panUrl;
                  link.download = "pan";
                  link.target = "_blank";
                  link.click();
                }
              } catch (err) {
                console.error("PAN download failed:", err);
              }
            };

            return (
              <Tooltip
                title={
                  params.row?.kycInfo?.nameProofType === "pan"
                    ? "Download PAN"
                    : "PAN not uploaded"
                }
              >
                <span>
                  <IconButton
                    disabled={params.row?.kycInfo?.nameProofType !== "pan"}
                    onClick={handleDownload}
                  >
                    <DownloadIcon />
                  </IconButton>
                </span>
              </Tooltip>
            );
          };
        row.width = 100;
        break;

        case "aadhar":
          row.filterable = false;
          row.renderCell = params => {
            return <>
              <Tooltip title={!params.row?.kycInfo?.addressProofType ? 'Upload Aadhaar' : 'Aadhaar already uploaded'}>
                <IconButton onClick={() => {
                  // if (params.row?.kycInfo?.addressProofType !== 'aadhaar')
                    setShowUploadAadhar(params.row);
                }}>
                  {params.row?.kycInfo?.addressProofType === 'aadhaar' ? <AssignmentTurnedInIcon /> : <FileUploadIcon />}
                </IconButton>
              </Tooltip>
            </>
          }
          row.width = 60;
          break;

        case "mobileNumber":
          row.width = 120;
          row.type = 'string';
          row.filterOperators = customStringOperators
          break;

        case "partnerId":
          row.width = 100;
          row.type = 'string';
          break;

        case "mainAccountNo":
          row.width = 150;
          row.type = 'string';
          break;

        case "kycStatus":
          row.type = 'string';
          row.renderCell = params => {
            return params.row.kycStatus === 'Y' ? 'Valid' : 'Invalid'
          }
          break;

        case "isCorporate":
          row.type = 'string';
          row.renderCell = params => {
            return params.row.isCorporate === 'Y' ? 'Yes' : 'No'
          }
          break;

        case "customerRefNo":
          row.width = 150;
          row.type = 'string';
          row.renderCell = params => {
            return params.row.customerRefNo ? params.row.customerRefNo : 'NA'
          }
          break;

        case "fullName":
          row.width = 150;
          row.type = 'string';
          row.renderCell = params => {
            return params.row.fullName ? params.row.fullName : 'NA'
          }
          break;

        case "emailAddress":
          row.width = 120;
          row.type = 'string';
          row.renderCell = params => {
            return params.row.emailAddress ? params.row.emailAddress : 'NA'
          }
          break;

        case "userType":
          row.type = 'string';
          row.renderCell = params => {
            return params.row.userType ? params.row.userType : 'NA'
          }
          break;
        case "kycInfo":
          row.type = 'string';
          row.minWidth = 150;
          row.renderCell = params => {
            return params.row.kycInfo?.nameProofDocNo || 'NA'
          }
          break;
      }

      return row
    })
  }

  const onFilterChange = useCallback((filterModel: GridFilterModel) => {
   setFilterModel(filterModel)
  }, [])

  return (
    <div style={{ padding: '0 10px' }}>
      <div style={CARD_HEADER}>
        <Title style={CARD_HEADING}>Customer Setup</Title>
        <Button variant='contained' onClick={handleCustomer} >{'Add Customer'}</Button>
      </div>
      <div style={{ overflow: 'hidden' }}>
        <Table
          getRowId={(row) => row.customerRefNo}
          columns={getCustomerColumns()}
          rows={customers}
          paginationModel={paginationModel}
          onPaginationModelChange={(model) => setPaginationModel(model)}
          pageSizeOptions={[]}
          hideFooter={false}
          rowCount={count}
          paginationMode='server'
          filterMode="server"
          filterDebounceMs={1000}
          onFilterModelChange={onFilterChange}
        />
      </div>
      <Divider />
      <Modal open={typeof showUploadAadhar != 'boolean'} title={'Upload Aadhar'} onClose={handleCloseAadhar}>
        <CustomerAadharUpload customerDetail={showUploadAadhar as ICustomerSummary} modalClose={handleCloseAadhar} onSuccess={fetchCustomers} />
        {/* {showUploadAadhar ? <CustomerAadharUpload customerRefNo={customerDetail} modalClose={setShowUploadAadhar} /> : <></>} */}
      </Modal>
      <Modal open={typeof showUploadPAN != 'boolean'} title={'Upload PAN'} onClose={handleClosePAN}>
        <CustomerPanUpload customerDetail={showUploadPAN as ICustomerSummary} modalClose={handleClosePAN} onSuccess={fetchCustomers} />
      </Modal>
      <ConfirmPhoneModal
        open={Boolean(showMobileInput)}
        onClose={() => setShowMobileInput(false)}
        onConfirm={() => confimrPhoneHandler()}
        customerRefNo={typeof showMobileInput === 'string' ? showMobileInput : ''}
      />
    </div>
  )
}

export default CustomerSetup
